import envVar from '../../config/envVars';
import { ImportedChequeStatusReportResponse } from '../../types/chequeStatusType';
import authenticationUtils from '../../utils/authenticationUtils';
import httpClient from '../httpClient';

const uploadChequeStatusReport = async (
  file: File,
  onProgress: (percent: number) => void
): Promise<ImportedChequeStatusReportResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const url = `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/transactions/import/cheque-status-report`;
  const response: any = await httpClient.put(url, formData, {
    headers: {
      Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
    },
    onUploadProgress: (e) => {
      const percent = Math.round((e.loaded * 100) / (e.total ?? 1));
      onProgress(percent);
    }
  });
  return response as ImportedChequeStatusReportResponse;
};

const chequeStatusReportApis = {
  uploadChequeStatusReport
};

export default chequeStatusReportApis;
